import { SaleResponse } from '@anm/api/modules/pricing';
import VideoSlider, { VideoSliderProps } from '@anm/components/VideoSlider';
import PricingContactUsSection from '@anm/components/pricing/PricingContactUsSection';
import PricingTable, { PricingTableProps } from '@anm/components/pricing/PricingTable';
import AskedQuestionsSection, { AskedQuestionsSectionProps } from '@anm/components/sections/AskedQuestionsSection';
import { FC } from 'react';

import DiscountBanner from '../DiscountBanner';
import PricingSectionTitleBlock from '../PricingSectionTitleBlock';

import { PricingSectionBottomWrapper, PricingSectionTopWrapper, PricingSectionVideoSliderWrapper } from './Wrapper';

export type PricingSectionDiscount = SaleResponse & {
  text: string;
};

export type PricingSectionProps = PricingTableProps &
  VideoSliderProps & {
    discount?: PricingSectionDiscount;
    collapseQuestions?: AskedQuestionsSectionProps['openIds'];
  };

const PricingSection: FC<PricingSectionProps> = ({
  discount,
  videoData,
  sliderData,
  collapseQuestions,
  seasonalDiscount,
  ...otherProps
}) => {
  return (
    <>
      <PricingSectionTopWrapper>
        {seasonalDiscount?.annual && <DiscountBanner discount={seasonalDiscount?.annual.discount * 100} />}
        <PricingSectionTitleBlock />
        <PricingTable seasonalDiscount={seasonalDiscount} {...otherProps} />
        <PricingContactUsSection />
      </PricingSectionTopWrapper>
      <PricingSectionVideoSliderWrapper>
        <VideoSlider {...{ sliderData, videoData }} />
      </PricingSectionVideoSliderWrapper>
      <PricingSectionBottomWrapper>
        <AskedQuestionsSection openIds={collapseQuestions} />
      </PricingSectionBottomWrapper>
    </>
  );
};

export default PricingSection;
